<app-form-field-render [field]="self">
  <ng-select
    #select
    [items]="items"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [placeholder]="placeholder"
    [searchable]="searchable"
    [clearable]="clearable"
    [compareWith]="compareWith"
    [virtualScroll]="true"
    [appendTo]="appendTo"
    [formControl]="ctrl"
    [searchFn]="searchFunc"
    (search)="onSearch($event)"
    (open)="onSelectDropdownOpen()"
    (close)="onSelectDropdownClose()"
    [ngClass]="'form-control'"
    [loading]="loading"
    [class.is-invalid]="isTouchedInvalid"
  >
    <ng-template ng-header-tmp *ngIf="searchable">
      <div class="custom-select-header">
        <div class="custom-select-search-wrapper">
          <input
            #customSearchInput
            class="custom-select-search pl-1"
            type="text"
            [placeholder]="searchPlaceholder"
            [formControl]="searchCtrl"
          />
          <span class="custom-search-clear" *ngIf="searchCtrl.value" (click)="onClearSearch()">×</span>
        </div>
      </div>
    </ng-template>

    <ng-template ng-label-tmp let-item="item" let-index="index">
      <ng-template
        [ngTemplateOutlet]="selectItemLabel?.templateRef || defaultOptionTemplate"
        [ngTemplateOutletContext]="{ item: item, index: index, label: getItemLabel(item) }"
      >
      </ng-template>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index">
      <ng-template
        [ngTemplateOutlet]="selectOptionItem?.templateRef || defaultOptionTemplate"
        [ngTemplateOutletContext]="{ item: item, index: index, label: getItemLabel(item) }"
      >
      </ng-template>
    </ng-template>
  </ng-select>
</app-form-field-render>

<ng-template #defaultOptionTemplate let-label="label">
  <div class="text-truncate">{{ label }}</div>
</ng-template>
